module.exports = __webpack_public_path__ + "static/media/Thursday.642f2e07.ogg";